export const DEFAULT_LIMIT = 20

export const initialTableReducer = {
  items: [],
  limit: DEFAULT_LIMIT,
  offset: 0,
  total: 0
}

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export enum CertificateStatuses {
  ISSUED = 'issued',
  REVOKED = 'revoked',
  EXPIRED = 'expired'
}

export enum FeatureFlags {
  ENABLE_ACTIVATE_STEP = 'enableActivateStepForDsmSigner',
  ENABLE_ACCOUNT_MIGRATION= 'AM_enable_account_migration',
  ENABLE_TLM_PACKAGING= 'AM_enable_packaging',
  ENABLE_STM_PACKAGING= 'AM_enable_stm_packaging',
  ENABLE_QC_PACKAGING= 'AM_enable_qc_packaging',
  AM_ALLOW_UNLINK_ACCOUNT= 'AM_allow_unlink_account'
}

export const DIGIROOT_ID = '00000000-0000-0000-0000-000000000000'


export enum AccountFeatures {
  STM_TRIAL_ACCOUNT = 'ftr_sm_trial_account',
  STM_KEYLOCKER_ACCOUNT ='ftr_sm_keylocker_account',
  STM_PUBLIC_ISSUANCE = 'ftr_sm_public_issuance',
  DIGICERT_TRUST_ASSISTANT = 'ftr_em_digicert_trust_assistant'
}

export const CM_ISSUANCE_PROFILE_MANAGEMENT = 'ftr_cm_issuance_profile_management'
export enum CMProtocolFeatures {
  EST = 'ftr_cm_protocol_est',
  SCEP = 'ftr_cm_protocol_scep',
  CMP = 'ftr_cm_protocol_cmp',
  ACME = 'ftr_cm_protocol_acme'
}

export const SystemAccount = 'System Account'

export enum STMApplicationName {
  SECURE_SOFTWARE = 'Software Trust',
  KEYLOCKER = 'KeyLocker'
}

export const DEVICE_TRUST_MANAGER = 'Device Trust Manager'

export const UNLIMITED = 'Unlimited'
